module.exports = __webpack_public_path__ + "media/images/front/programs/icon-check-26a7a131acee55ea8a5b6cda61501a01.svg";